import React, { forwardRef, useImperativeHandle, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { useSnackbar } from 'notistack';

import { formatDateDDMMYYYYHHmm } from '../../utils';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const AreaCopiaCola = forwardRef((props, ref) => {
  const [produtos, setProdutos] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useImperativeHandle(ref, () => ({
    guardar(id, item) {
      const copy = produtos.slice();
      const index = copy.findIndex((item) => item.id === id);
      if (index >= 0) {
        copy.splice(index, 1);
        enqueueSnackbar(`Item removido da lista do COPIA E COLA! (${item})`, {
          variant: 'error',
        });
      } else {
        copy.push({ id, conteudo: item });
        enqueueSnackbar(`Item adicionado na lista do COPIA E COLA! (${item})`, {
          variant: 'success',
        });
      }
      setProdutos(copy);
    },
  }));

  async function copiar() {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(
        `Cotação de preços Caruaru Frios ${formatDateDDMMYYYYHHmm(
          new Date(),
        )}\n${produtos.map((item) => item.conteudo).join('\n')}`,
      );
      setProdutos([]);
      enqueueSnackbar('Código copiado para a área de transferência!', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar('Não tem acesso a api de copia e cola!', {
        variant: 'error',
      });
    }
  }

  const textDica = produtos.map((item, index) => (
    <div style={{ fontSize: '15px', whiteSpace: 'nowrap', color: 'black' }}>
      {`${index + 1} - ${item.conteudo}`}
    </div>
  ));

  const containerDica = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {textDica}
    </div>
  );

  return (
    <>
      {produtos.length > 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <HtmlTooltip
            title={containerDica}
            placement="bottom"
            aria-label="excluir2"
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '2px solid green',
                borderRadius: '7px',
                margin: '10px 0px',
                padding: '5px',
                width: 'min-content',
                gap: '10px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  whiteSpace: 'nowrap',
                  color: 'green',
                }}
              >
                {`* ${produtos.length} PRODUTOS NA ÁREA DE TRANSFERÊNCIA`}
              </div>
              <Tooltip title="Copiar" placement="bottom" aria-label="add2">
                <IconButton
                  aria-label="check"
                  size="small"
                  onClick={() => copiar()}
                >
                  <FilterNoneIcon />
                </IconButton>
              </Tooltip>
            </div>
          </HtmlTooltip>
        </div>
      ) : null}
    </>
  );
});

export default AreaCopiaCola;
